<template>
  <div class="app-page-container">
    <div class="app-body">
      <h3 class="text-danger">{{$t("forbiddenRequest.title")}}</h3>
         <div class="step-bar-bg">
      <p class="desc"> {{$t("forbiddenRequest.desc")}}  </p>
      </div>
        <div class="btn-for-vertical">
        <button class="game-button primary" @click="$router.push({ name: 'Home'})" >
         {{$t("nav.home")}}
      </button>
      </div>
    </div>
    <description></description>
    <footerBar @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
import footerBar from "../components/common/footer";
import description from "../components/common/description";
// import { Toast } from "mint-ui";
// var moment = require("moment");
export default {
  data() {
    return {};
  },
  components:{footerBar,description},
  methods: {  
    showLanguage(){
      this.$emit('showLanguage')
    }
  },
};
</script>
<style lang="less" scoped>
.text-danger {
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
}
.desc{
      font-size: 0.34rem;
    // margin-bottom: 0.5rem;
}
.step-bar-bg{
  background: #F1F1F1 ;
      border-radius: 0.32rem;
      padding: 0.42rem;
      margin-bottom: 0.42rem;
}

@media screen and (orientation: landscape) {
.btn-for-vertical{
  width: 60%;
  margin: 0 auto;
  padding-left: .6rem;
  padding-right:  .6rem;
  box-sizing: border-box;
  }
  .text-danger {
    text-align: center;
}
}
</style>